import React from 'react'
import Skeleton from 'react-loading-skeleton'

export const SkeletonThumbnailWithContent: React.FC = () => {
	return (
		<div>
			<div className="h-250px">
				<Skeleton height="100%" containerClassName="avatar-skeleton" />
			</div>

			<div className="mt-10">
				<Skeleton count={3} />
			</div>
		</div>
	)
}

export const SkeletonThumbnailWithTitle: React.FC = () => {
	return (
		<div>
			<div className="h-200px">
				<Skeleton height="100%" containerClassName="avatar-skeleton" />
			</div>

			<div className="mt-10 d-flex justify-content-end align-items-end">
				<div style={{ width: '60%' }}>
					<Skeleton />
				</div>
			</div>
		</div>
	)
}

export const SkeletonHighCard: React.FC = () => {
	return (
		<div className="w-200px">
			<div className="h-400px">
				<Skeleton height="100%" containerClassName="avatar-skeleton" />
			</div>

			<div className="mt-10">
				<Skeleton count={1} />
			</div>
		</div>
	)
}

export const SkeletonFullWidthWithContent: React.FC = () => {
	return (
		<div>
			<div className="h-250px">
				<Skeleton height="100%" containerClassName="avatar-skeleton" />
			</div>

			<div className="mt-10">
				<Skeleton count={3} />
			</div>
		</div>
	)
}
